import { createSelector } from 'reselect'

const getUnitID = state => state.unitID
const getEquipment = state => state.equipment
const getInventory = state => state.inventory

const getEquipedItemIDs = createSelector(
    getUnitID,
    getEquipment,
    (unitID, equipment) => (
        Object.values(equipment).reduce((arr, entry) => {
            if (entry.unitID === unitID) { arr.push(entry.itemID) }
            return arr
        }, [])
    )
)

const getEquipedItems = createSelector(
    getEquipedItemIDs,
    getInventory,
    (equippedItemIDs, inventory) => inventory.filter(item => equippedItemIDs.includes(item.ID))
)

export default getEquipedItems
